import { Component } from "@angular/core";

@Component({
    selector: "cerrix-page-footer",
    imports: [],
    templateUrl: "./cerrix-page-footer.component.html",
    styleUrl: "./cerrix-page-footer.component.scss",
})
export class CerrixPageFooterComponent {}
